<template>
  <div>
    <arhslgl-base-header-sec title="Архива просветног гласника" slug="pgarh"></arhslgl-base-header-sec>
    <div class="container-fluid base-container">
      <div class="tab-form sp_tab-form">
        <form class="w-100">
          <div class="row">
            <div class="col-lg-6">
              <div class="row">
                <div class="col-lg-4">
                  <div class="form-group form-group-sm">
                    <label for="donosilac" class="form-label">Доносилац</label>
                    <select id="donosilac" v-model="donosilac" class="form-control full-width">
                      <option value selected="selected"></option>
                      <option v-for="item in authorities" v-bind:key="item.k" :label="item.l" :value="item.k">{{ item.l }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="form-group form-group-sm">
                    <label for="vrsteDokumenata" class="form-label">Врсте докумената</label>
                    <select id="vrsteDokumenata" v-model="vrsteDokumenata" class="form-control full-width">
                      <option value selected="selected"></option>
                      <option v-for="item in docTypes" v-bind:key="item.k" :label="item.l" :value="item.k">{{ item.l }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="form-group form-group-sm">
                    <label for="godina" class="form-label">Година</label>
                    <select id="godina" v-model="godina" class="form-control full-width">
                      <option value selected="selected"></option>
                      <option v-for="item in years" v-bind:key="item.k" :label="item.l" :value="item.k">{{ item.l }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group form-action text-right">
                <div class="spacer30"></div>
                <button class="btn btn-primary btn-sm text-nowrap" @click="search" type="button">
                  <span class="icon-search mr-2"></span> Пронађи
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
      <!-- <div class="base-box base-box__accordion-sec ">
                <div class="mb-5 accordion   " role="tablist">
                    <b-card no-body v-for="(item, year_index) in searchYears" v-bind:key="item"
                            class="ac_card">
                        <b-card-header header-tag="header" class="ac_card-header" role="tab">
                            <b-button class="btn btn-block accordion-title-btn"
                                      variant="none"
                                      block
                                      href="#"
                                      @click="open(item, year_index)"
                                      v-b-toggle="'accordion-'+item">
                                {{item}}
                            </b-button>
                        </b-card-header>
                        <b-collapse :id="'accordion-'+item"
                                    :visible=" isCollapseVisible(item)"
                                    class="ac_collapse scroll_to_collapse"
                                    accordion="my-accordion"
                                    role="tabpanel">
                            <b-card-body>
                                <div class="ac_collapse__item-list">
                                    <div class="ac_sub-cat">
                                        <div class="table-responsive">
                                            <table class="table table-striped">
                                                <tr>
                                                    <th>БРОЈ</th>
                                                    <th>ГЛАСИЛО</th>
                                                    <th>ДАТУМ</th>
                                                    <th>HTML</th>
                                                    <th>PDF</th>
                                                    <th>ВЕЛИЧИНА</th>
                                                </tr>
                                                <tr v-for="row in yearResults[year_index]" v-bind:key="row.id">
                                                    <td>{{row.numStr}}</td>
                                                    <td>{{row.issueTypeShortDescription}}</td>
                                                    <td>{{row.publishDateStr}}</td>
                                                    <td>
                                                        <router-link class="table-html-link"
                                                                     :to=" 'arhslgl/numberOverview/muarh/' + row.id">
                                                            HTML
                                                        </router-link>
                                                    </td>
                                                    <td>
                                                        <a class="table-pdf-link" v-if="canOpen==='can_open'"
                                                           :href="baseApiUrl+'api/slglrs/pdf?id='+row.id"
                                                           target="_blank">
                                                            PDF
                                                        </a>
                                                        <a class="table-pdf-link" v-if="canOpen==='not_logged_in'"
                                                           v-b-modal.login-modal href="#" @click.stop.prevent>
                                                            PDF
                                                        </a>
                                                        <a class="table-pdf-link" v-if="canOpen==='role_not_allowed'"
                                                           href="#" @click.stop.prevent="role_not_allowed()">
                                                            PDF
                                                        </a>
                                                    </td>
                                                    <td>{{row.pdfDocumetSizeKB}} KB</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </div>
                <div v-if="isActOpen" class="p-5">
                    ovo je zakon
                    <button @click="print">
                        <span class="icon-printer"></span>
                    </button>
                    <div v-html="actHTML" id="html_to_printing"></div>
                </div>
      </div>-->

      <!-- //my way begin -->
      <div class="base-box base-box__accordion-sec">
        <div v-for="(item, index) in searchYears" :key="index">
          <div class="ac_card-header">
            <b-card-header header-tag="header" class="ac_card-header" role="tab">
              <a class="btn btn-block accordion-title-btn" @click="toggleItem(item, index)">
                <!-- <a class=" " href="#"> -->
                <div class="test">
                  <div>
                    <span class="span">{{ item }}</span>
                  </div>
                  <div class="row-display-flex">
                    <div class="pipe"></div>
                    <div class="second-div">
                      <i :class="classArrow(index)"></i>
                    </div>
                  </div>
                </div>
                <!-- </a> -->

                <!-- <transition name="slide"> -->
                <div v-if="isActive === index" class="item-active">
                  <div class="ac_collapse__item-list">
                    <div class="ac_sub-cat">
                      <div class="table-responsive">
                        <table class="table table-striped">
                          <tr>
                            <th>БРОЈ</th>
                            <th>ГЛАСИЛО</th>
                            <th>ДАТУМ</th>
                            <th>HTML</th>
                            <th>PDF</th>
                            <th>ВЕЛИЧИНА</th>
                          </tr>
                          <tr v-for="row in datica" v-bind:key="row.id">
                            <td>{{ row.numStr ? row.numStr : 1 }}</td>
                            <td>{{ row.issueTypeShortDescription }}</td>
                            <td>{{ row.publishDateStr }}</td>
                            <td>
                              <router-link class="table-html-link"
                                :to="'arhslgl/numberOverview/pgarh/' + row.id">HTML</router-link>
                            </td>
                            <td>
                              <router-link v-if="canOpen === 'can_open'" :to="'slglrsViewPdf/' + row.id"
                                class="table-pdf-link" target="_blank">
                                PDF</router-link>
                              <a class="table-pdf-link" v-if="canOpen === 'not_logged_in'" v-b-modal.login-modal href="#"
                                @click.stop.prevent>PDF</a>
                              <a class="table-pdf-link" v-if="canOpen === 'role_not_allowed'" href="#"
                                @click.stop.prevent="role_not_allowed()">PDF</a>
                            </td>
                            <td>{{ row.pdfDocumetSizeKB }} KB</td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- </transition> -->
              </a>
            </b-card-header>
          </div>
        </div>
      </div>

      <!-- my way end-->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import ArhslglBaseHeaderSec from "@/base_pages/arhslgl/ArhslglBaseHeaderSec.vue";
import { mapState } from "vuex";

export default {
  name: "ArhslglPgarhPage",
  data() {
    return {
      isToggled: false,
      newD: "",
      isActive: false,
      datica: [],
      isActOpen: false,
      actHTML: "",
      itemList: [],
      baseApiUrl: window.env.VUE_APP_API_SLGL_DEV,
      authorities: [],
      docTypes: [],
      years: [],
      searchYears: [],
      yearResults: [],
      activeYear: null,
      donosilac: "",
      vrsteDokumenata: "",
      godina: "",
      meta: {
        title: "Правно-информациони систем РС",
        description:
          "Правно-информациони систем je збирка података у електронском облику која садржи: електронски облик Службеног гласника, архиву службених гласила, базу која садржи регистар и текстове важећих прописа и других аката Републике Србије објављених у Службеном гласнику, базу која садржи судску праксу, друге податке о правном систему Републике Србије и везу с правним актима Европске уније.",
        keywords:
          "zakoni, akti, zakonski, propisi, sudska praksa, registar, odluka, sudovi, ugovori, pravno informacioni sistem, prins, pis,sluzbeni glasnik"
      }
    };
  },
  metaInfo() {
    return {
      title: this.meta.title,
      meta: [
        { name: "title", content: this.meta.title },
        { name: "description", content: this.meta.description },
        { name: "keywords", content: this.meta.keywords }
      ]
    };
  },
  components: {
    ArhslglBaseHeaderSec
  },
  computed: {
    ...mapState(["userInfoState"]),
    canOpen() {
      if (this.userInfoState) {
        if (this.userInfoState.roles.includes("PGARHSTARO")) {
          return "can_open";
        } else {
          return "role_not_allowed";
        }
      } else {
        return "not_logged_in";
      }
    }
  },
  methods: {
    classArrow(index) {
      return { "arrow down": true, right: this.isActive === index };
    },

    role_not_allowed() {
      alert("Немате приступ овој бази");
    },
    print() {
      this.$htmlToPaper("html_to_printing");
    },
    search() {
      axios
        .get(
          this.baseApiUrl +
          "prins/archive/overview/PGARHSTARO/searchYears" +
          this.paramString()
        )
        .then(response => {
          this.searchYears = response.data;
          this.activeYear = null;
          this.yearResults = [];
        });
    },
    open(item, index) {
      if (this.activeYear !== item) {
        this.activeYear = item;
        this.yearResults = [];
        var url = this.baseApiUrl + "Prins/arhslgl/overview/PGARHSTARO/fetchYear";
        var params = [];
        if (this.donosilac !== "") params.push("authority=" + this.donosilac);
        if (this.vrsteDokumenata !== "")
          params.push("docType=" + this.vrsteDokumenata);
        params.push("year=" + item);
        url += "?" + params.join("&");
        axios.get(url).then(response => {
          this.$set(this.yearResults, index, response.data);
        });
      }
    },
    paramString() {
      var params = [];
      if (this.donosilac !== "") params.push("authority=" + this.donosilac);
      if (this.vrsteDokumenata !== "")
        params.push("docType=" + this.vrsteDokumenata);
      if (this.godina !== "") params.push("year=" + this.godina);
      if (params.length > 0) {
        return "?" + params.join("&");
      }
      return "";
    },
    openAct(actId) {
      axios
        .get(this.baseApiUrl + "api/RegistarServlet/act-" + actId)
        .then(response => {
          this.actHTML = response.data;
        });
      this.isActOpen = true;
    },
    fetchData() {
      axios
        .get(this.baseApiUrl + "prins/arhslgl/overview/PGARHSTARO/filter")
        .then(response => {
          this.authorities = response.data.authorities;
          this.docTypes = response.data.docTypes;
          this.years = response.data.years;
        });
      axios
        .get(this.baseApiUrl + "prins/archive/overview/PGARHSTARO/searchYears")
        .then(response => {
          this.searchYears = response.data;
          for (var i = 0; i < this.searchYears.length; i++) {
            this.yearResults[i] = [];
          }
        });
    },
    isCollapseVisible(cat_index) {
      return cat_index === 0;
    },
    toggleItem(item, index) {
      setTimeout(() => {
        this.isActive = this.isActive === index ? null : index;
        this.datica = [];
      }, 0);
      this.activeYear = item;
      this.yearResults = [];
      var url = this.baseApiUrl + "Prins/arhslgl/overview/PGARHSTARO/fetchYear";
      var params = [];
      if (this.donosilac !== "") params.push("authority=" + this.donosilac);
      if (this.vrsteDokumenata !== "")
        params.push("docType=" + this.vrsteDokumenata);
      params.push("year=" + item);
      url += "?" + params.join("&");
      axios.get(url).then(response => {
        setTimeout(() => {
          this.datica = response.data;
        }, 0);
      });
    }
  },
  created() {
    this.fetchData();
  },
  beforeCreate: function () {
    document.body.className = "color_arhslgl";
  }
};
</script>


<style scoped>
.main {
  background-color: #ddd !important;
  padding-bottom: 360px !important;
}

.card-header {
  padding: unset !important;
}

.accordion-title-btn {
  padding: 12px;
  text-align: left;
  padding-left: 30px;
  background: white;
}

.span {
  color: #706f6f;
  font-weight: 700;
}

.test {
  display: flex;
  /* width: 100%; */
  justify-content: space-between;
  /* margin: 0 0px; */
  padding: 10px 20px !important;
  align-items: center;
}

.row-display-flex {
  display: flex;
}

.pipe {
  border-right: solid 1px black;
  height: 30px;
  margin-right: 40px;
}

.accordion-title-btn[data-v-388df273] {
  padding: unset !important;
}

p {
  margin-top: 0 !important;
  margin-bottom: 1rem !important;
}

i {
  border: solid black;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 3px;
}

.down {
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
}

.right {
  transform: rotate(225deg);
  -webkit-transform: rotate(225deg);
}

.second-div {
  padding-right: 20px;
}

.up {
  transform: rotate(-135deg);
  -webkit-transform: rotate(-135deg);
}

.accordion-title-btn {
  padding: unset !important;
}
</style>